import SuperAdminDashboard from "layouts/dashboard/index.js";

export default SuperAdminDashboard;
